(function () {
  function init(root) {
    if (!root || root.dataset.ivmReady === 'true') return;
    root.dataset.ivmReady = 'true';

    var variants = JSON.parse(root.querySelector('[data-ivm-variants]').textContent);
    var moneyFormat = JSON.parse(root.querySelector('[data-ivm-money-format]').textContent);
    var form = root.querySelector('.ivm-product-form');
    var variantInput = root.querySelector('[data-ivm-variant-id]');
    var groups = Array.from(root.querySelectorAll('[data-ivm-option]'));
    var slides = Array.from(root.querySelectorAll('[data-ivm-slide]'));
    var thumbs = Array.from(root.querySelectorAll('[data-ivm-thumb]'));
    var prices = Array.from(root.querySelectorAll('[data-ivm-price]'));
    var addButtons = Array.from(root.querySelectorAll('[data-ivm-add]'));
    var addLabels = Array.from(root.querySelectorAll('[data-ivm-add-label]'));
    var status = root.querySelector('[data-ivm-status]');
    var counter = root.querySelector('[data-ivm-counter]');
    var primaryAdd = root.querySelector('[data-ivm-primary-add]');
    var stickyBar = root.querySelector('[data-ivm-sticky-bar]');
    var stickyColor = root.querySelector('[data-ivm-current-color]');
    var stickySize = root.querySelector('[data-ivm-current-size]');

    function formatMoney(cents) {
      var amount = (Number(cents) / 100).toFixed(2);
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(cents) / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function showMedia(index) {
      var safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      slides.forEach(function (slide, i) {
        slide.hidden = i !== safeIndex;
        slide.classList.toggle('is-active', i === safeIndex);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.setAttribute('aria-current', i === safeIndex ? 'true' : 'false');
      });
      counter.textContent = String(safeIndex + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
    }

    function selectedOptions() {
      return groups.map(function (group) {
        var selected = group.querySelector('[data-ivm-option-value].is-selected');
        return selected ? selected.dataset.ivmOptionValue : '';
      });
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, i) { return option === options[i]; });
      });
    }

    function updateAvailability(options) {
      groups.forEach(function (group, groupIndex) {
        group.querySelectorAll('[data-ivm-option-value]').forEach(function (button) {
          var candidate = options.slice();
          candidate[groupIndex] = button.dataset.ivmOptionValue;
          var available = variants.some(function (variant) {
            return variant.available && variant.options.every(function (option, i) { return option === candidate[i]; });
          });
          button.disabled = !available;
          button.setAttribute('aria-disabled', String(!available));
        });
      });
    }

    function showColorMedia(color) {
      var needle = (color || '').toLowerCase();
      var index = slides.findIndex(function (slide) {
        var alt = slide.dataset.mediaAlt || '';
        return alt.includes(needle) && alt.includes('product view');
      });
      if (index < 0) index = slides.findIndex(function (slide) { return (slide.dataset.mediaAlt || '').includes(needle); });
      if (index >= 0) showMedia(index);
    }

    function update(options, changedPosition) {
      var variant = findVariant(options);
      var available = Boolean(variant && variant.available);
      if (changedPosition === 1) showColorMedia(options[0]);
      updateAvailability(options);
      variantInput.value = variant ? variant.id : '';
      if (variant) prices.forEach(function (node) { node.textContent = formatMoney(variant.price); });
      addButtons.forEach(function (button) { button.disabled = !available; });
      addLabels.forEach(function (label, i) {
        label.textContent = variant ? (available ? (i === 0 ? 'Add to cart' : 'Add') : 'Sold out') : 'Unavailable';
      });
      stickyColor.textContent = options[0] || '—';
      stickySize.textContent = options[1] || '—';
      status.textContent = !variant ? 'This option combination is unavailable.' : (!available ? 'This option is currently sold out.' : '');
      if (variant) {
        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', nextUrl.toString());
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(Number(thumb.dataset.mediaIndex)); });
    });

    groups.forEach(function (group) {
      group.addEventListener('click', function (event) {
        var button = event.target.closest('[data-ivm-option-value]');
        if (!button || !group.contains(button) || button.disabled) return;
        group.querySelectorAll('[data-ivm-option-value]').forEach(function (candidate) {
          var selected = candidate === button;
          candidate.classList.toggle('is-selected', selected);
          candidate.setAttribute('aria-pressed', String(selected));
        });
        group.querySelector('[data-ivm-option-current]').textContent = button.dataset.ivmOptionValue;
        update(selectedOptions(), Number(group.dataset.optionPosition));
      });
    });

    form.addEventListener('submit', function (event) {
      if (!variantInput.value || addButtons.some(function (button) { return button.disabled; })) {
        event.preventDefault();
        status.textContent = 'Please choose an available color and size.';
      }
    });

    if (stickyBar && primaryAdd && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting && window.innerWidth < 990);
      }).observe(primaryAdd);
      window.addEventListener('resize', function () {
        if (window.innerWidth >= 990) stickyBar.classList.remove('is-visible');
      });
    }

    update(selectedOptions(), 0);
  }

  function boot() { document.querySelectorAll('[data-ivm-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
